import { Configuration } from '@app/config/configuration';
import { Injectable } from '@angular/core';
import { COMPANY_NAMES } from '@app/config';
declare var $: any;

@Injectable()
export class SettingsService {

    public user: any;
    public app: any;
    public layout: any;

    constructor() {

        // User Settings
        // -----------------------------------
        this.user = {
            name: 'John',
            job: 'ng-developer',
            picture: 'assets/img/user/02.jpg'
        };

        let companyName = 'The Prod Process';//'THE LIFT';
        if (Configuration.COMPANY_NAME === COMPANY_NAMES.CINEBURO) {
            companyName = 'Cineburó';
        }
        if(Configuration.COMPANY_NAME=== COMPANY_NAMES.THE_ENT){
            companyName = 'THE LIFT'
        }

        // App Settings
        // -----------------------------------
        this.app = {
            name: companyName,
            description: 'Angular Bootstrap Admin Template',
            year: ((new Date()).getFullYear())
        };

        

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

    }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }
    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

}



// WEBPACK FOOTER //
// ./src/app/core/settings/settings.service.ts